'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AlphaSlider", {
    enumerable: true,
    get: function() {
        return AlphaSlider;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useAlphaSlider = require("./useAlphaSlider");
const _renderAlphaSlider = require("./renderAlphaSlider");
const _useAlphaSliderStylesstyles = require("./useAlphaSliderStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const AlphaSlider = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useAlphaSlider.useAlphaSlider_unstable)(props, ref);
    (0, _useAlphaSliderStylesstyles.useAlphaSliderStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useAlphaSliderStyles_unstable')(state);
    return (0, _renderAlphaSlider.renderAlphaSlider_unstable)(state);
});
AlphaSlider.displayName = 'AlphaSlider';
